/** @deprecated */
export const createRequestActionNames = (name: string, argMethods: string[] = [], argStatuses: string[] = []) => {
  const methods = argMethods.length ? argMethods : ['GET', 'POST', 'PATCH', 'DELETE']
  const statuses = argStatuses.length ? argStatuses : ['REQUEST', 'SUCCESS', 'FAIL']
  return methods.reduce((result, method) => {
    result[method] = statuses.reduce((innerResult, status) => {
      innerResult[status] = `${name}/${method}_${status}`
      return innerResult
    }, {})
    return result
  }, {})
}
